import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import s from './returnsButton.module.css';
import { Spinner } from '../Spinner';

export const ReturnsButton = ({ className, loading, disabled, onClick, tier, big, children }) => (
  <button
    className={cx(
      'return-button',
      'btn',
      s.button,
      {
        'narvar-btn-primary': tier === 'primary',
        'narvar-btn-secondary': tier === 'secondary',
        'narvar-btn-tertiary': tier === 'tertiary',
        [s.button_big]: big,
      },
      className,
    )}
    data-test="return-button-next"
    disabled={disabled}
    onClick={onClick}
  >
    <p className={cx('return-button-text', s.button_text)}>{children}</p>
    <div className={s.button_spinner_container}>
      <span className="returns-spinner">{loading && <Spinner width="30" />}</span>
    </div>
  </button>
);

ReturnsButton.defaultProps = {
  loading: undefined,
  disabled: undefined,
  onClick: undefined,
  tier: undefined,
  big: undefined,
  children: undefined,
  className: undefined,
};

ReturnsButton.propTypes = {
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  tier: PropTypes.string,
  big: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
};
